module.exports = __webpack_public_path__ + "img/zryycl32.5f5424e5.svg";